<template>
  <div class="card">
    <div class="grid grid-cols-6 gap-2">

      <div class="col-span-6">
        <div class="p-4 mb-4 text-sm text-blue-700 bg-blue-100 rounded-lg dark:bg-blue-200 dark:text-blue-800" role="alert">
          <span class="font-medium">Empresa:</span> {{data.empresa}}
        </div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <label for="periodo" class="m-4">Periodo</label>
        <Calendar inputId="periodo" v-model="data.periodo" view="month" dateFormat="yy-mm" class="mr-4" />
      </div>

      <div class="col-span-6 sm:col-span-3">
        <Button label="Agregar Afiliado" /> 
      </div>

      <div class="col-span-6">
        <DataTable ref="dt" :value="afiliados" :scrollable="true" scrollHeight="400px" scrollDirection="both"
                   rowGroupMode="subheader" groupRowsBy="afiliados.cuitTitular"
                   filterDisplay="menu" v-model:filters="filters" showGridlines class="p-datatable-sm">

          <template #header>
            <div class="flex items-center flex-col md:justify-between md:flex-row">
              <h5 class="mb-2 md:m-0 p-as-md-center">Afiliados</h5>
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText v-model="filters['global'].value" placeholder="Buscar..." />
              </span>
            </div>
          </template>

          <Column field="cuil" header="CUIL" :sortable="true" style="min-width:12rem">
            <template #body="{data}">
              {{data.cuil}}
            </template>
            <template #filter="{filterModel}">
              <InputText type="text" v-model="filterModel.value" placeholder="Buscar por ..." />
            </template>
          </Column>
          <Column field="nombre" header="Nombre" :sortable="true" style="min-width:30rem">
            <template #body="{data}">
              {{data.nombre}}
            </template>
            <template #filter="{filterModel}">
              <InputText type="text" v-model="filterModel.value" placeholder="Buscar por ..." />
            </template>
          </Column>
          <Column field="familiar" header="Familiar" :sortable="true" style="min-width:20rem">
            <template #body="{data}">
              {{data.familiar}}
            </template>
            <template #filter="{filterModel}">
              <InputText type="text" v-model="filterModel.value" placeholder="Buscar por ..." />
            </template>
          </Column>
          <Column field="edad" header="Edad" :sortable="true" style="min-width:8rem"></Column>
          <Column field="valorCuota" header="Valor Cuota" :sortable="true" style="min-width:16rem">
            <template #body="slotProps">
              {{formatCurrency(slotProps.data.valorCuota)}}
            </template>
          </Column>
          <Column header="Acciones" :exportable="false" style="min-width:8rem" frozen alignFrozen="right">
            <template #body="slotProps">
              <div class="grid grid-cols-6 gap-2">
              </div>
            </template>
          </Column>
        </DataTable>
      </div>

    </div>
  </div>
</template>

<script>
  import { ref, reactive, onMounted } from 'vue';
  import WService from '@/plugins/ws';
  import { FilterMatchMode, FilterOperator } from 'primevue/api';
  import Calendar from 'primevue/calendar';
  import Button from 'primevue/button';
  import DataTable from 'primevue/datatable';
  import InputText from 'primevue/inputtext';
  import Column from 'primevue/column';

  export default {
    components: {
      Calendar, Button, DataTable, InputText, Column,
    },
    props: {
      info: Object,
    },
    emits: ["closeModal"],
    setup(props, { emit }) {
      onMounted(() => {

      });

      const wService = ref(new WService());
      const data = reactive({
        periodo: '',
        empresa: props.info.empresa,
      });
      const filters = ref({
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'nombre': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        'familiar': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      });

      const afiliados = ref([]);

      const formatCurrency = (value) => {
        if (value)
          return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        return;
      };

      const save = () => {
        emit("closeModal");
      };

      return {
        data, filters, afiliados,

        formatCurrency, save,
      }
    }
  }
</script>